<template>
  <div
    v-if="fragment.src"
    class="c-player-sprite"
  >
    <div
      ref="wrapper"
      class="c-player-sprite__img"
      :style="spriteStyles"
    ></div>
  </div>
</template>
<script>
  export default {
    name: 'UiPlayerSprite',
    props: {
      hoverTime: Number,
      sprites: Object,
      spriteUrl: String,
      isChannel: Boolean,
      previewDay: Number,
    },
    computed: {
      spriteStyles() {
        return {
          backgroundImage: `url(${this.fragment.src})`,
          backgroundPositionY: `-${this.fragment.offsetTop}px`,
          paddingTop: `${this.fragment.aspectRatio * 100}%`,
        };
      },
      hoverTimestamp() {
        return this.hoverTime * 1000;
      },
      spriteLink() {
        return this.spriteUrl.replace(/\/+$/, '');
      },
      fragment() {
        const wrapper = this.$refs.wrapper;
        const sprites = this.sprites.sprites;
        const config = this.sprites.config;

        // Find fragment containing dts closest to hover timestamp
        const fragment = this.isChannel
          ? sprites[0]
          : sprites.find(({ dts }) => {
            const min = dts[0];
            const max = dts[dts.length - 1];
            return this.hoverTimestamp >= min && this.hoverTimestamp <= max;
          });

        if (!fragment) {
          return {};
        }
        // Within fragment find index closest to the timestamp
        const closest = fragment.dts.reduce((previous, timestamp, index) => {
          return Math.abs(timestamp - this.hoverTimestamp) < Math.abs(previous.timestamp - this.hoverTimestamp)
            ? { timestamp, index }
            : previous;
        }, { timestamp: 0, index: 0 });

        return {
          src: `${this.spriteLink}${this.isChannel && this.previewDay ? `/${this.previewDay}` : ''}/${fragment.path}`,
          offsetTop: wrapper && wrapper.getBoundingClientRect().height * closest.index,
          aspectRatio: config.height / config.width,
        };
      },
    },
  };
</script>
